import cn from 'classnames';
import { FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useEditorForm } from '@features/clients/editor-group/model/use-editor-form';
import { useFormSubmit } from '@features/clients/editor-group/model/use-form-submit';
import { useGroupLoader } from '@features/clients/editor-group/model/use-group-loader';
import { ArrowShortLeft, Group } from '@shared/assets';
import { Card, IconButton, ListBody, PageHead, PageTitle, Textarea, TextButton } from '@shared/ui';
import { Loader } from '@src/library/components/common';
import * as st from './styles.module.scss';

export const EditGroup: React.FC = () => {
  const { idGroup } = useParams();
  const navigate = useNavigate();
  const editorFormData = useEditorForm(Number(idGroup));

  const error = !!editorFormData.methods.formState.errors.name;
  const titleValue = editorFormData.methods.watch('name');

  // const linkBack = `/clients/groups/${idGroup}`;

  const onClose = () => {
    navigate(
      // linkBack
      -1
    );
  };

  const { isLoading } = useGroupLoader(Number(idGroup));
  const { onGroupSubmit, uploadStatus } = useFormSubmit(Number(idGroup), onClose);

  return (
    <>
      <PageTitle title={idGroup === 'new' ? 'Новая группа' : 'Редактирование группы'} />
      <PageHead
        Left={
          <div className={st.button}>
            {/* <IconButton variant="dark" onClick={onCloseDialog}> */}
            <IconButton
              variant="dark"
              onClick={() =>
                navigate(
                  // state && state.path
                  //   ? `${state.path}`
                  //   : `/clients/groups/${idGroup !== 'new' ? idGroup : ''}`
                  -1
                )
              }
            >
              <ArrowShortLeft />
            </IconButton>
          </div>
        }
        Right={
          <TextButton
            type="submit"
            disabled={uploadStatus === 'loading'}
            onClick={editorFormData.methods.handleSubmit(onGroupSubmit)}
          >
            Готово
          </TextButton>
        }
      />
      <ListBody>
        {isLoading ? (
          <Loader />
        ) : (
          <FormProvider {...editorFormData.methods}>
            <form
              onSubmit={editorFormData.methods.handleSubmit(onGroupSubmit)}
              className={st.editor}
            >
              <fieldset className={st.fieldset}>
                <Card className={st.title}>
                  <div className={st.wrapper}>
                    <div className={st.title__image}>
                      <Group />
                    </div>

                    <div className={st.title__text_desktop}>
                      <Textarea
                        autosize
                        firstLetterUppercase
                        {...editorFormData.methods.register('name')}
                        disabled={Boolean(uploadStatus === 'loading')}
                        required={error}
                      />
                      {!titleValue && (
                        <div className={st.placeholder}>
                          <span className={cn(st.placeholder__text, error && st.error)}>
                            Название
                          </span>
                          <span className={st.placeholder__sign}>*</span>
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              </fieldset>
            </form>
          </FormProvider>
        )}
      </ListBody>
    </>
  );
};

export default EditGroup;
